<template>
  <ts-loading-banner :loading="waiting">
    <div class="ts-space-y-4">
      <div class="row">
        <div class="col-12 ts-space-y-1">
          <label class="required">{{ $t('bankProfile.bankName') }}</label>
          <input
            v-model="model.bank_name"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('bank_name') }"
          />
          <div class="invalid-feedback" v-if="errors.has('bank_name')">
            {{ errors.first('bank_name') }}
          </div>
        </div>
        <div class="col-12 ts-space-y-1 ts-mt-3">
          <label>{{ $t('bankProfile.bankAddress') }}</label>
          <input
            v-model="model.bank_address"
            type="text"
            class="form-control"
          />
        </div>
      </div>
      <div class="row">
        <detail-template
          v-model="model"
          :validation="errors"
          class="ts-w-full"
        />
      </div>
      <div class="row ts-mt-2">
        <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting_new"
            :disabled="waiting_new || waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t('save_add_new') }}</ts-button
          >
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t('save')
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import DetailTemplate from './components/detail.vue'
export default {
  name: 'bankProfileForm',
  components: {
    DetailTemplate
  },
  data () {
    return {
      objectContain: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      banks: [],
      model: {
        bank_id: null,
        bank_name: null,
        bank_address: null,
        detail: []
      }
    }
  },
  created () {
    this.setEditData()
  },
  computed: {
    ...mapState('bankProfile', ['edit_data']),
    isUpdate () {
      return !isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('bankProfile/store', Object.assign({}, this.model))

        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'bank-profile' })
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('bankProfile/store', Object.assign({}, this.model))
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'bank-profile' })
          this.clearEdit()
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate () {
      this.waiting = true
      this.$store
        .dispatch('bankProfile/update', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'bank-profile' })
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      if (!isEmpty(this.edit_data)) {
        this.model.bank_id = this.edit_data.bank_id
        this.model.bank_name = this.edit_data.bank_name
        this.model.bank_address = this.edit_data.bank_address
        this.edit_data.bank_accounts.map(el =>
          this.model.detail.push({
            account_id: el.account_id,
            account_name: el.account_name,
            account_number: el.account_number,
            remarks: el.remarks ? el.remarks : null,
            swift_code: el.swift_code ? el.swift_code : null
          })
        )
      }
    },
    clearEdit () {
      this.model.bank_id = null
      this.model.bank_name = null
      this.model.bank_address = null
      this.model.detail = []
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>
